import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-operario',
  templateUrl: './footer-operario.component.html',
  styleUrls: ['./footer-operario.component.css']
})
export class FooterOperarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
